<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                        <v-flex >Add Module Material</v-flex>
                        <v-btn icon @click="CloseDialog">
                            <v-icon color="text--secondary">close</v-icon>
                        </v-btn>
                    </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;">
                        <v-flex>
                            <v-select item-value='Course_Id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title" @change="GetCourseSectionList">
                                <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Course_Title }}
                                  </template>
                                  <template slot='item' slot-scope='{ item }'>
                                        {{ item.Course_Title }}    
                                  </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedSection" :items="GetSectionList" label="Select Module Title">
                                  <template slot='selection' slot-scope='{ item }'>
                                        {{ item.Section_Title }}
                                  </template>
                                  <template slot='item' slot-scope='{ item }'>
                                        {{ item.Section_Title }}    
                                  </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <upload-button title="Button With Icon" multiple @file-update="UpdateFile"></upload-button>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" @click="SubmitCurriculamMaterial">Submit Module Material</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";
import UploadButton from 'vuetify-upload-button';


export default {
    components: {
        VueEditor,
        UploadButton
    },
    props: ['dialog'],
    data(){
        return {

            SelectedCourseDetail    : {},
            SelectedSection         : {},
            Section_Description     : "",
            Current_Course_Details  : {},
            Online                  : false,
            Files                   : null,
            Image                   : null
        }
    },
    computed:{
        GetCourseDetailList(){

            return this.$store.getters.GetCourseDetailsList
        },
        GetSectionList(){

            return  this.$store.getters.GetCourseSection
        }
    },
    methods:{
        UpdateFile(files) {
            this.Files = files;
        },
        CloseDialog(){
            this.ClearForm()
            this.$emit('close');
        },
        GetCourseSectionList(){

            let data = {}
            data["Course_Id"] = this.SelectedCourseDetail['_id']
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/getsections`,data)
                        .then(response =>{

                            if(response["data"]["response"]){

                                this.$store.commit('SetCourseSection',response["data"]["response"]["Course_Curriculam"])
                                return this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getcoursedetails`,data)

                            }else{

                                this.$store.commit('SetCourseSection',null)
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Add Course Sections","Color":"red","Close": false });

                            }
                             
                        })
                        .then(response =>{

                            this.Current_Course_Details = response['data']['response']
                            this.Online = this.Current_Course_Details.Course_Types.includes('Online')
                                
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },
        SubmitCurriculamMaterial(){

            const fd = new FormData();
            fd.append("Course_Id", this.SelectedCourseDetail['_id']);
            fd.append("Section_Id", this.SelectedSection['Section_Id']);
            Array.from(Array(this.Files.length).keys()).map(x => {
                fd.append('Study_Material', this.Files[x], this.Files[x].name);
            });
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/addsectionmaterial`,fd)
                        .then(response =>{
                            
                            this.$store.commit('SetCourseCurriculamList',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Added Section Successfully","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Section","Color":"green","Close": false });
                        })
        },
        ClearForm(){

            this.SelectedCourseDetail    = {}
            this.SelectedSection         = {}
            this.Current_Course_Details  = {}
            this.Files                   = []
            this.Section_Description     = ""
            this.Online                  = false
        },
        GetCourseDetailsList(){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        },
    }
}
</script>
<style scoped>

</style>